import * as React from "react";

import { ModalContentType } from "src/components/shared/Modal/ModalProvider";

export interface ModalContextType {
  openFixedModal(node: ModalContentType, onBeforeClose?: () => void): void;
  closeModal(): void;
  isOpen?:boolean;
}

const ModalContext = React.createContext<ModalContextType>({
  openFixedModal: () => {
    throw new Error("You probably forgot to put <ModalContext.Provider>!");
  },
  closeModal: () => {
    throw new Error("You probably forgot to put <ModalContext.Provider>!");
  },
});

export default ModalContext;
